import React, { useEffect, useState } from 'react';
import fileDownload from 'js-file-download';

import './styles.css';

import icLogout from '../../assets/images/logout.svg';
import download from '../../assets/images/download.svg';

import ModalReport from '../modals/ModalReport';
import ModalReportSuccess from '../modals/ModalReportSuccess';

import { logout } from '../../services/auth';

import api from '../../services/api';
import getUserInfo from "../../services/getUserInfo";

let isDownloading = false;

export const Header = (props) => { 
  const [showReport, setShowReport] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [canDownload, setCanDownload] = useState(false);

  useEffect(() => {
    getUserInfo().then(user => {
      setCanDownload(user.isDiretor || user.isMaster);
    });
  }, []);
  
  const downloadReport = () => {
    if(isDownloading){
      return true;
    }

    isDownloading = true;

    let date = new Date();
    let d = date.getDate();
    let m = date.getMonth() + 1;
    let y = date.getFullYear();

    let filename = `${y}-${m}-${d}_relatório_${props.area}.xlsx`;

    api.get(`${props.area}/download-extrato`, {
      responseType: 'blob'
    }).then(res => {
      setShowReport(false);
      setShowSuccess(true);
      
      setTimeout(() => {
        fileDownload(res.data, filename);
      }, 1000);
      
      isDownloading = false;
    }).catch(error => {
      isDownloading = false;
      setShowReport(false);
      setShowSuccess(false);
      alert(`Ocorreu um erro: ${error}`);
    });

    return true;
  };

  return (
    <>
    {showReport && downloadReport() &&
      <ModalReport handleClose={() => setShowReport(false)} handleModal={() => setShowSuccess(true)} profile={ props.area } />
    }
    {showSuccess && 
      <ModalReportSuccess handleClose={() => setShowSuccess(false)}  />
    }

    <div id="header" className="blue">
      <div className="section-title">
        <div className="d-flex">
          {props.icon}
          <h1>{props.title} <small>{props.subtitle}</small></h1>          
          <div className={`beta ${props.showBeta ? 'show' : 'hide'}`}>
              <p>Beta</p>
          </div>
        </div>
        {canDownload &&
          <div className={`download ${props.showDownload ? 'show' : 'hide'}`}>
              <button type="button" onClick={() => setShowReport(true) }>
                  <div id="bg-btn-check">
                      <img src={download} alt="Icon" />
                  </div>
                  <p>Baixar lista</p>
              </button>
          </div>
        }
      </div>
      <div className="section-logout">
        <button type="button" onClick={() => {
          logout();
          window.location.href="/";
        }}><img src={icLogout} />Sair</button>
      </div>
    </div>
  </>
  );
  
}

export default Header;